import * as constants from '../../constants'
import { IDriversState, IDriverSearchObject, IStepsCreateDriver, IStoreState } from '../../../types'
import { IDriverActions } from '../../actions/drivers'
import { EntityStepState } from '../../../components/ui/entity/EntityStepBarItem'

const stepsCreateDriver: IStepsCreateDriver[] = [
  {
    id: 0,
    index: 1,
    name: 'PERSONAL INFO',
    state: EntityStepState.CURRENT
  },
  {
    id: 1,
    index: 2,
    name: 'PROVIDERS & PRODUCTS',
    state: EntityStepState.REGULAR
  }
]
const InitialState: IDriversState = {
  items: {},
  liveOperators: [],
  itemsRequest: false,
  itemsError: '',
  showDrivers: 'TODO',
  isChangeStatusRequesting: false,
  lastMutableElement: null,
  historyDriverTrips: [],
  isHistoryDriverTripsRequesting: false,
  historyDriverTripsError: '',
  selectedHistoryTrip: null,
  selectedDriver: null,
  isSelectedDriverFetch: false,
  selectedDriverError: null,
  stepsCreateDriver,
  ownProviderRequesting: false,
  ownProvider: undefined,
  ownProviderError: '',
  processing: false,
  processingError: '',
  totalDrivers: 0,
  sessionHistory: {},
  totalSessions: 0,
  sessionRequest: false,
  sessionError: '',
  filters: {},
  accumulatedHours: undefined,
  operatorSchedule: [],
  operatorScheduleError: '',
  operatorScheduleRequest: false,
  operatorLocation: undefined,
  operatorLocationError: '',
  operatorLocationRequest: false,
  operatorMetricsRequest: false,
  operatorMetrics: []
}

export function drivers(state: IDriversState, action: IDriverActions): IDriversState {
  if (typeof state === 'undefined') {
    return InitialState
  }
  switch (action.type) {
    case constants.LIVE_OPERATORS_REQUEST: {
      return { ...state }
    }
    case constants.LIVE_OPERATORS_SUCCESS: {
      return { ...state, liveOperators: action.payload }
    }
    case constants.LIVE_OPERATORS_FAIL: {
      return { ...state, processingError: action.payload }
    }
    case constants.OPERATOR_REMOVE_PRODUCT_REQUEST: {
      return Object.assign({}, state, {
        itemsRequest: true,
        showDrivers: 'TODO'
      })
    }
    case constants.OPERATOR_REMOVE_PRODUCT_SUCCESS: {
      //TODO see what we need to do here
      const items = { ...state.items }
      items[action.payload.id].productIds = action.payload.products.map(p => p.id)
      items[action.payload.id].products = action.payload.products
      return Object.assign({}, state, { items })
    }
    case constants.DRIVERS_LIST_REQUEST:
      return Object.assign({}, state, {
        itemsRequest: true,
        showDrivers: 'TODO'
      })
    case constants.DRIVERS_LIST_SUCCESS: {
      return Object.assign({}, state, {
        itemsRequest: false,
        items: action.payload.drivers,
        totalDrivers: action.payload.total
      })
    }

    case constants.DRIVERS_LIST_FAIL:
      return Object.assign({}, state, {
        itemsError: action.payload
      })

    case constants.DRIVER_SESSION_LIST_REQUEST:
      return Object.assign({}, state, {
        sessionRequest: true
      })
    case constants.DRIVER_SESSION_LIST_SUCCESS: {
      return Object.assign({}, state, {
        sessionRequest: false,
        sessionHistory: action.payload.drivers,
        totalSessions: action.payload.total
      })
    }

    case constants.DRIVER_SESSION_LIST_FAIL:
      return Object.assign({}, state, {
        sessionError: action.payload
      })

    case constants.DRIVER_SESSION_LIST_V2_REQUEST:
      return Object.assign({}, state, {
        sessionRequest: true
      })

    case constants.DRIVER_SESSION_LIST_V2_SUCCESS: {
      return Object.assign({}, state, {
        sessionRequest: false,
        sessionHistory: action.payload.drivers,
        totalSessions: action.payload.total
      })
    }

    case constants.DRIVER_SESSION_LIST_V2_FAIL:
      return Object.assign({}, state, {
        sessionError: action.payload
      })

    case constants.DRIVER_CREATE_SESSION_SUCCESS: {
      return Object.assign({}, state, {
        sessionRequest: false,
        sessionHistory: { ...state.sessionHistory, [state.totalSessions - 1]: action.payload },
        totalSessions: state.totalSessions + 1
      })
    }
    case constants.TO_ARCHIVED_DRIVER_REQUEST: {
      return Object.assign({}, state, {
        isChangeStatusRequesting: true
      })
    }
    case constants.TO_ARCHIVED_DRIVER_FAIL: {
      return Object.assign({}, state, {
        itemsError: action.payload
      })
    }
    case constants.RESTORE_ARCHIVED_DRIVER_REQUEST: {
      return Object.assign({}, state, {
        isChangeStatusRequesting: true
      })
    }
    case constants.DRIVER_ARCHIVE_RESTORE_SUCCESS: {
      const driver = action.payload
      const items = { ...state.items }
      delete items[driver.id]
      return Object.assign({}, state, {
        items,
        isChangeStatusRequesting: false,
        lastMutableElement: driver
      })
    }
    case constants.RESTORE_ARCHIVED_DRIVER_FAIL:
      return Object.assign({}, state, {
        itemsError: action.payload
      })
    case constants.TRIP_HISTORY_DRIVER_REQUEST:
      return Object.assign({}, state, {
        isHistoryDriverTripsRequesting: true
      })
    case constants.TRIP_HISTORY_DRIVER_SUCCESS:
      return Object.assign({}, state, {
        isHistoryDriverTripsRequesting: false,
        selectedHistoryTrip: action.payload[0],
        historyDriverTrips: action.payload
      })
    case constants.TRIP_HISTORY_DRIVER_FAIL:
      return Object.assign({}, state, {
        isHistoryDriverTripsRequesting: false,
        itemsError: action.payload
      })
    case constants.FETCH_DRIVER_REQUEST:
      return Object.assign({}, state, {
        isSelectedDriverFetch: true
      })
    case constants.FETCH_DRIVER_SUCCESS: {
      const driver = action.payload
      return Object.assign({}, state, {
        isSelectedDriverFetch: false,
        items: {
          ...state.items,
          [driver.id]: driver
        },
        selectedDriver: driver
      })
    }
    case constants.FETCH_DRIVER_FAIL:
      return Object.assign({}, state, {
        selectedDriverError: action.payload
      })
    case constants.ADD_DRIVER_INFO_REQUEST:
      return Object.assign({}, state, {
        processing: true
      })
    case constants.ADD_DRIVER_INFO_SUCCESS:
      const driver = action.payload
      return Object.assign({}, state, {
        processing: false,
        processingError: '',
        items: {
          ...state.items,
          [driver.id]: driver
        }
      })
    case constants.ADD_DRIVER_INFO_FAIL:
      return Object.assign({}, state, {
        processing: false,
        processingError: action.payload
      })
    case constants.ADD_PRODUCTS_TO_DRIVER_REQUEST:
      return Object.assign({}, state, {
        processing: true,
        processingError: null
      })
    case constants.ADD_PRODUCTS_TO_DRIVER_SUCCESS_MESSAGE:
      return Object.assign({}, state, {
        processing: false,
        processingError: null,
        success: action.payload
      })
    case constants.ADD_PRODUCTS_TO_DRIVER_FAIL:
      return Object.assign({}, state, {
        processing: false,
        processingError: action.payload
      })
    case constants.UPDATE_DRIVER_FILTERS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      })
    }
    case constants.GET_OPERATOR_SCHEDULE_REQUEST: {
      return Object.assign({}, state, {
        operatorScheduleRequest: true
      })
    }
    case constants.GET_OPERATOR_LOCATION_REQUEST: {
      return Object.assign({}, state, {
        operatorLocationRequest: true
      })
    }
    case constants.GET_OPERATOR_LOCATION_SUCCESS: {
      return Object.assign({}, state, {
        operatorLocationRequest: false,
        operatorLocation: action.payload
      })
    }
    case constants.GET_OPERATOR_LOCATION_FAIL: {
      return Object.assign({}, state, {
        operatorLocationRequest: false,
        operatorLocationError: action.payload
      })
    }
    case constants.GET_OPERATOR_METRICS_REQUEST: {
      return Object.assign({}, state, {
        operatorMetricsRequest: true
      })
    }
    case constants.GET_OPERATOR_METRICS_SUCCESS: {
      return Object.assign({}, state, {
        operatorMetricsRequest: false,
        operatorMetrics: action.payload
      })
    }
    case constants.GET_OPERATOR_METRICS_FAIL: {
      return Object.assign({}, state, {
        operatorMetricsRequest: false,
        operatorMetrics: action.payload
      })
    }
    case constants.GET_OPERATOR_SCHEDULE_SUCCESS: {
      const { payload } = action
      return Object.assign({}, state, {
        operatorSchedule: payload,
        operatorScheduleRequest: false
      })
    }
    case constants.GET_OPERATOR_SCHEDULE_FAIL: {
      const { payload } = action
      return Object.assign({}, state, {
        operatorScheduleRequest: false,
        operatorScheduleError: payload
      })
    }
    case constants.DRIVER_PUSH_NOTIFICATION_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        error: null,
        success: action.payload
      })
    }
    case constants.DRIVER_PUSH_NOTIFICATION_FAIL: {
      return Object.assign({}, state, {
        error: action.payload,
        success: null
      })
    }
  }
  return state
}

// Driver selectors

export const getDriverProcessing = (state: IStoreState): boolean => {
  return state.drivers.processing
}

export const getDriverProcessingError = (state: IStoreState): string => {
  return state.drivers.processingError
}

export const getDriverById = (state: IStoreState, driverId: string): IDriverSearchObject | undefined => {
  return state.drivers.items[driverId]
}



// WEBPACK FOOTER //
// ./src/state/reducers/drivers/index.ts